import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, AreaChart, Area } from "recharts";
import { getContractByMonth } from "../../../../../redux/contractSlice/contractSlice";

const timeRangeOptions = [
  { value: "all", label: "الكل" },
  { value: "6", label: "6 أشهر" },
  { value: "3", label: "3 أشهر" },
];

const getLastNMonthsData = (data, months) => {
  if (months === "all") return data;
  const monthsNum = parseInt(months);
  const dataLength = data.length;
  return data.slice(Math.max(dataLength - monthsNum, 0));
};

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="p-4 border rounded shadow-lg" dir="rtl">
        <p className="text-sm font-medium text-gray-900">{label}</p>
        <p className="text-sm text-gray-600">التعاقدات: {payload[0].value}</p>
      </div>
    );
  }
  return null;
};

export default function ContractsChart() {
  const [data, setData] = useState([]);
  const [timeRange, setTimeRange] = useState("all");
  const [chartHeight, setChartHeight] = useState(355);
  const dispatch = useDispatch();
  const { contractByMonth } = useSelector((state) => state.contract);

  useEffect(() => {
    dispatch(getContractByMonth());
  }, [dispatch]);

  useEffect(() => {
    if (contractByMonth?.length) {
      const formattedData = contractByMonth.map((item) => ({
        name: item.yearMonth,
        التعاقدات: item.count,
      }));
      console.log(formattedData);
      setData(getLastNMonthsData(formattedData, timeRange));
    }
  }, [contractByMonth, timeRange]);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width <= 480) {
        setChartHeight(250);
        if (timeRange === "all") {
          setTimeRange("3");
        }
      } else if (width <= 768) {
        setChartHeight(300);
      } else {
        setChartHeight(355);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [timeRange]);

  const handleRangeChange = (e) => {
    setTimeRange(e.target.value);
  };

  return (
    <div className="card ">
      <div className="card-header p-4 border-b">
        <div className="flex flex-row items-center justify-between">
          <h2 className="text-xl font-bold">التعاقدات</h2>
          <div className="flex items-center text-center gap-2" dir="rtl">
            <label className="text-sm text-gray-600">الفترة:</label>
            <select value={timeRange} onChange={handleRangeChange} className="border rounded px-3 py-1 text-sm">
              {timeRangeOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      <div className="card-body p-4">
        <ResponsiveContainer width="100%" height={chartHeight}>
          <AreaChart data={data} margin={{ top: 10, right: 10, left: 10, bottom: 20 }}>
            <defs>
              <linearGradient id="colorContracts" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#8884d8" stopOpacity={0.8} />
                <stop offset="95%" stopColor="#8884d8" stopOpacity={0.1} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" className="opacity-50" />
            <XAxis dataKey="name" tick={{ fill: "#666", fontSize: 12 }} tickMargin={10} />
            <YAxis tick={{ fill: "#666", fontSize: 12 }} tickMargin={10} />
            <Tooltip content={<CustomTooltip />} />
            <Area type="monotone" dataKey="التعاقدات" stroke="#8884d8" fill="url(#colorContracts)" strokeWidth={2} />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
